<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div
        type="primary"
        class="main-content"
        style="height:100%;display: flex;flex-direction: column"
      >
        <search-item
          config-module="601"
          :reset="true"
          :is-append-query="true"
          no="1"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button type="success" no="5" @click="toAdd(true)">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" no="6" @click="toAdd(false)">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" no="7" @click="toBatchDelete()">{{ $t('common.btn.delete') }}</el-button>
            <el-button type="primary" no="8" @click="toEnable()">{{ $t('common.btn.enable') }}</el-button>
            <el-button type="danger" no="12" @click="toDisable()">{{ $t('common.btn.disable') }}</el-button>
          </div>
        </search-item>

        <div class="section grid-wrapper">
          <cargo-ag-grid-wrapper
            config-module="1301001"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            style="flex:1;width: 100%;height: 100%"
            no="9"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="!appendQuery"
            config-module="1100011"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            no="10"
            @pagination="toQuery"
          />
          <div v-show="appendQuery" class="pagination-container">
            <el-pagination

              style="text-align: left;"
              :total="filter.total"
              layout="total"
            />
          </div>
        </div>
        <!-- 新增船公司约号-->
        <shipping-contract-window
          :visible.sync="ShippingContractWindow.visible"
          :form.sync="form"
          :filter-json="filterJson"
          :title="formTitle"
          :is-edit="isEdit"
          @close="ShippingContractWindow.visible=false"
          @refresh="toQuery"
        />
      </div>
    </div>
  </div>

</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { stringToBool } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { cache } from '@/utils/cacheManager'
import {
  deleteShippingContract,
  enableShippingContract,
  findByshippingContractNo, getNacInfo,
  shippingContractPage
} from '@/api/price/priceFcl'
import RegisterWindow from '@/views/cargo/v0/SeaExport/MblManagement/components/RegisterWindow.vue'
import ShippingContractWindow from '@/views/cargo/v0/Price/ShippingContract/ShippingContractWindow.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
export default {
  name: 'ShippingContract',
  components: { CargoAgGridWrapper, ShippingContractWindow, RegisterWindow, cargoAdvanceSelect, searchItem, cargoCloudFileUpload },
  data() {
    return {
      loading: null,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      appendQuery: false, // 追加查询
      selectTypeNames: TYPE_NAMES,
      formTitle: '',
      form: {
        uuid: '',
        contractNumber: '',
        applicableRoutes: [],
        shippingCompany: '',
        priceNature: '',
        weatherNac: '',
        applicableProducts: '',
        productName: '',
        mqc: '',
        cabinGuarantee: '',
        cabinQuantity: '',
        cabinUnit: '',
        validityStart: null,
        validityEnd: null,
        weatherEnabled: true,
        defaultParam: '',
        nacList: [],
        uuids: [],
        removeUuids: [],
        uuidToNacMap: new Map()
      },
      isEdit: false, // 是否修改
      ShippingContractWindow: {
        visible: false
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'contractNumber',
          width: 150
        },
        {
          headerName: this.$t('Message.ApplicableRoute'),
          field: 'applicableRoutes',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveAirline(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'shippingCompany',
          width: 150,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          }
        },
        {
          headerName: this.$t('SeaExport.ContractRateProperty'),
          field: 'priceNature',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.priceNatureLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.IsNac'),
          field: 'weatherNac',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', stringToBool(params.value), 'chineseName')
          }
        },
        {
          headerName: 'NAC',
          colId: 'nac',
          field: 'nac',
          width: 200,
          tooltipField: 'nac'
        },
        {
          headerName: this.$t('SeaExport.ApplicableProductName'),
          field: 'applicableProducts',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.applicableProductsLabelFunction(params.value)
          }
        },
        {
          headerName: 'MQC',
          field: 'mqc',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CargoInsurance'),
          field: 'cabinGuaranteeRemark',
          width: 150,
          valueGetter: (params) => {
            return ColumnUtils.cabinGuaranteeRemarkLabelFunction(params.data)
          },
          filterValueGetter: (params) => {
            return ColumnUtils.cabinGuaranteeRemarkLabelFunction(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.BeginDate'),
          field: 'validityPeriod',
          colId: 'validityPeriod',
          width: 150,
          valueGetter: (params) => {
            return ColumnUtils.validityPeriodLabelFunction(params.data)
          },
          filterValueGetter: (params) => {
            return ColumnUtils.validityPeriodLabelFunction(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WhetherItIsEnabled'),
          field: 'weatherEnabled',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', stringToBool(params.value), 'chineseName')
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  computed: {
    url() {
      return URL
    }
  },

  methods: {
    fetchShippingContractRequirement() {
      this.loading = getLoading()
      shippingContractPage(this.filter).then(res => {
        this.filter.total = Number(res.data.total)
        this.rowData = res.data.list
      }).catch(() => {}).finally(() => {
        this.loading.close()
      })
    },

    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.contractNumber = keyword
        this.filter.pageNum = 1
      }
      findByshippingContractNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    handleQueryData(res) {
      const curSelected = this.gridOptions.api.getSelectedRows().map(item => item.uuid)
      let results = res.data.list
      // 追加查询数据去重
      if (this.appendQuery) {
        const idSet = this.rowData.reduce((acc, v) => {
          acc[v.uuid] = true
          return acc
        }, {})
        const list = results.filter(v => !idSet[v.uuid])
        results = [...this.rowData, ...list]
        this.filter.total = Number(results.length)
      } else {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
      }
      this.rowData = results
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (curSelected.length) {
        this.$nextTick(() => {
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.data.uuid && curSelected.find((id) => id === node.data.uuid)) {
              node.setSelected(true)
            }
          })
        })
      }
    },
    toAdvancedQuery(data) {
      this.loading = getLoading()

      if (typeof data !== 'undefined') {
        // 获取追加查询条件
        data.forEach((element, index) => {
          if (Object.prototype.hasOwnProperty.call(element, 'appendQuery')) {
            this.appendQuery = element.appendQuery
            data.splice(index, 1)
          }
        })
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.appendQuery = this.appendQuery
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      shippingContractPage(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 删除
    async toBatchDelete() {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      // 如果被使用不可以删除
      const uuids = Array.from(rows, p => p.uuid)
      const scNos = Array.from(rows, p => p.contractNumber)
      const result = await SeaExportJob.isExistScNo(scNos)
      if (result > 0) {
        this.$message.warning(self.$t('SeaExport.ScNoIsUsed'))
        return
      }
      this.$confirm('<p style=" width: 300px; word-break: break-word">' + this.$t('SeaExport.PleaseToDeleteTheContract', [rows.length]) + '</p>', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return deleteShippingContract({ uuids }).then(res => {
          this.$message.success(this.$t('ProjectManage.DeletedSuccessfully'))
          this.fetchShippingContractRequirement()
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.DeletionCancelled'))
      })
    },
    // 启用
    toEnable() {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(self.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      const hasEnabledWeather = rows.some(p => p.weatherEnabled)
      if (hasEnabledWeather) {
        self.$message.warning(self.$t('SeaExport.EnableTips'))
        return
      }
      const uuids = Array.from(rows, p => p.uuid)
      const data = {
        uuids,
        weatherEnabled: true
      }
      this.$confirm('<p style=" width: 300px; word-break: break-word">' + this.$t('SeaExport.ConfirmEnableTips') + '</p>', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return enableShippingContract(data).then(res => {
          this.$message.success(this.$t('ProjectManage.DeletedSuccessfully'))
          this.fetchShippingContractRequirement()
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.DeletionCancelled'))
      })
    },
    toDisable() {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(self.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      const hasDisEnableWeather = rows.some(p => p.weatherEnabled === 0 || p.weatherEnabled === false)
      if (hasDisEnableWeather) {
        self.$message.warning(self.$t('SeaExport.ConfirmDisEnableTips'))
        return
      }
      const uuids = Array.from(rows, p => p.uuid)
      const data = {
        uuids,
        weatherEnabled: false
      }
      this.$confirm('<p style=" width: 300px; word-break: break-word">' + this.$t('SeaExport.DisEnableTips') + '</p>', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return enableShippingContract(data).then(res => {
          this.$message.success(this.$t('ProjectManage.DeletedSuccessfully'))
          this.fetchShippingContractRequirement()
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.DeletionCancelled'))
      })
    },
    // 新增
    async toAdd(isNew) {
      if (isNew) {
        this.form = {
          uuid: '',
          contractNumber: '',
          applicableRoutes: [],
          shippingCompany: '',
          priceNature: '',
          weatherNac: '',
          applicableProducts: '',
          productName: '',
          mqc: '',
          cabinGuarantee: '',
          cabinQuantity: '',
          cabinUnit: '',
          validityStart: null,
          validityEnd: null,
          weatherEnabled: true,
          defaultParam: '',
          nacList: []
        }
        this.isEdit = false
        this.formTitle = this.$t('CargoMsg.Cargo_NewTo')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length > 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.form = { ...rows[0] }
        if (this.form.nac) {
          this.form.removeUuids = []
          this.form.nacList = this.form.nac.split('|')
          this.form.defaultParam = this.form.nacList[0]
          const contractData = await getNacInfo({ uuid: this.form.uuid })
          const uuids = contractData.data.map(item => item.uuid)
          this.form.uuids = uuids
          this.form.nacList = this.form.nacList.slice(1).map((param, index) => ({
            param: param,
            uuid: uuids[index + 1] || '' // 防止越界
          }))
        }
        this.form.applicableRoutes = this.form.applicableRoutes
          ? this.form.applicableRoutes.split(',')
          : []
        if (!this.form.mqc) {
          this.form.mqc = ''
        }
        this.isEdit = true
        this.formTitle = this.$t('CargoMsg.Cargo_EditTo')
      }
      this.ShippingContractWindow.visible = true
    }
  }
}
</script>

<style scoped>
</style>
